export default "/images/ed0788c4dfeadc9816a03930edb92d81.avif";